import { createContext, useContext } from "react";
import { auth } from "./auth";
import closing from '../data/closeing.json';
import { v4 as uuidv4 } from 'uuid';
import { context } from "./context";


export const intialData = createContext();

export default function InitData ({children}) {
    const { ActivEmp,user } = useContext(auth);
    const { clientFlag } = useContext(context);
        const Async = {
            new: {
                status: 'f',
                reason: "new"
            },
            update: {
                status: 'f',
                reason: "update"
            },
            delete: {
                status: 'f',
                reason: "delete"
            }
    }

    const createInitBatch = () => ({
        id: uuidv4(),
        index: 0,
        name: "",
        productId: "",
        invId: "",
        meta: {
            expiredDate: "",
            createdAt: null,
            supplierId: ""
        },
        calcUnit: "",
        buyPrice: 0,
        currentQty: 0
    });
    const initSupplier = () => ({
        id: uuidv4(),
        supplierCompany: "",
        address: "",
        phone: "",
        email: "",
        contactPersonName: "",
        note: "",
        createdAt: "",
        async: Async.new,
    })
    const transactionOnBatch = () => ({
        id: uuidv4(),
        batchId: "",
        taker: ActivEmp.name,
        transactionType: "IN",
        unit: "piece",
        qty: 0,
        createdAt: ""
    })

    const initInventory = {
        id: uuidv4(),
        name: "",
        box:[]
    }
    const initResetPayOnline = {
        cash: "",
        benefits: "",
        totalVisa: "",
        status: false,
    };

    const intialCategory = {
        id: uuidv4(),
        name: "",
    };
    
    const initializeEmp = {
        code: "",
        user:'',
        password:"",
        fullName: "",
        details: {
            phone: "",
            address: "",
        },
        meta: {
            createdAt: {
                from: `${ActivEmp.code} - ${ActivEmp.name}`,
                date: ""
            },
            updatedAt: []
        },
        salary: {
            type: "",
            value: ""
        },
        job: "",
        status: '',
        shift: [],
        expenses: [],
        deductions: [],
        bouns: [],
    };
    const initialProductState = () => ({
    id: uuidv4(),
    taker: {
        emp: {
            id: ActivEmp.code,
            name: ActivEmp.name
        },
    },
    idStore: user.work.workName,
    nameProudct: "",
    meta: {
        barcode: "",
        createdAt: "",
        updateDate: "",
    },
    categoryId: "",
    sku: "",
    sellPrice: 0,
    type: "unit",
    discount: {
        discountType: "fixed",
        discountValue: 0
    },
    inventoryId: "",
    brand: "",
    tax: {
        taxType: "fixed",
        taxValue: 14,
    },
    isPublish: true,
    async: Async.new,
    });
    
    const intialConfig = {
        label: "configuration",
        ip: "127.0.0.1",
        // for paymob only :()
        workMode: "live",
        isAcceptPolicy: false,
        pos: "DV0",
        weight: {
            prefix:"20",
            cd: "1"
        },
        workWay: "both",
        mode: "light",
        weightManualMode: true,
    }
    const intialSocial = {
        label: "social",
        web: "",
        app: "",
        hotline: "0000",
    };
    const intialInvoice = {
        label: "invoice",
        closing: closing[1].desc,
        rules: {
            decision: "rr",
            time: "24"
        },
    };
    const initialWork = {
        label: "businessRules",
        techniqueOffset: "fifo",
        timeEmpWork: {
            delay: {
                min: 0,
                deduction: 0,
            },
            early: {
                min: 0,
                bouns: 0,
            },
        },
        monitorPilots: {
            normal: {
                min: 30,
                hours: 0,
            },
            warning: {
                min: 0,
                hours: 1,
            },
            danger: {
                min: 30,
                hours: 1,
            }
        }
    };
    const intialClient = {
            mode: clientFlag,
            client_name:"",
            address: "",
            phone_number:"",
            details: {
                floor: "",
                door: "",
                specialMark: ""
            },
            payment: 0,
    }
    const intialShift = {
        id: uuidv4(),
        code: "",
        fullName: "",
        job: "",
        date: {
            start: "",
            end: "",
        },
        action: {
            deduction: 0,
            bouns: 0,
        },
        today: "",
        async: Async.new
    }

    const parent = {
        Async,
        intialCategory, 
        initializeEmp, 
        initialProductState, 
        intialConfig, 
        intialSocial, 
        intialInvoice, 
        initialWork, 
        intialClient,
        intialShift,
        initResetPayOnline,
        initInventory,
        createInitBatch,
        transactionOnBatch,
        initSupplier
    };
    return <intialData.Provider value={parent}>{children}</intialData.Provider>
}